import { Controller } from "@hotwired/stimulus"

// Copies the install snippet. Falls back to selecting the text when the
// Clipboard API is unavailable (non-HTTPS origins, older browsers).
export default class extends Controller {
  static targets = ["source", "label"]
  static values = { copiedLabel: { type: String, default: "Copied" } }

  copy() {
    const text = this.sourceTarget.innerText.trim()

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(() => this.confirm())
    } else {
      this.selectSource()
    }
  }

  confirm() {
    if (!this.hasLabelTarget) return

    const original = this.labelTarget.textContent
    this.labelTarget.textContent = this.copiedLabelValue
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => { this.labelTarget.textContent = original }, 1600)
  }

  selectSource() {
    const range = document.createRange()
    range.selectNodeContents(this.sourceTarget)
    const selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
  }

  disconnect() {
    clearTimeout(this.resetTimer)
  }
}
